<template>
<v-row>
     <v-expansion-panels>
        <app-grants-production v-if="hasGrants" :id="id"></app-grants-production>
        <app-publications-production v-if="hasPublications" :id="id"></app-publications-production>
        <app-lecture-production v-if="hasLectures" :id="id"></app-lecture-production>
    </v-expansion-panels>
</v-row>
</template>
<script>
import grantsProduction from './GrantsProduction.vue';
import publicationsProduction from './PublicationsProduction.vue';
import lecturesProduction from './LecturesProduction.vue';
import {mapGetters}from 'vuex';
import { mapActions } from 'vuex';

export default {
    name:"Production",
    props:['id','hasPublications','hasGrants','hasLectures'],
    components:{
        'AppGrantsProduction':grantsProduction,
        'AppPublicationsProduction':publicationsProduction,
        'AppLectureProduction':lecturesProduction,
    },
    computed:{
        ...mapGetters('header',{
            xsOnly:'xsOnly'
        }),
    },
    created(){
        this.setShowDepartments(true);
    },
    methods:{
        ...mapActions('publication',{
            setShowDepartments:'setShowDepartments'
        }),
    }
}
</script>
